module.exports = "<div class=modal-header> <h3 class=modal-title>Paste Swagger JSON</h3> </div> <div class=modal-body> <div class=form-group> <label>Swagger JSON</label> <textarea class=form-control cols=30 rows=10 ng-model=json ng-change=checkJSON(json)></textarea> </div> <div ng-if=error> Error <json-formatter class=\"error json-formatter-dark\" json=error open=2></json-formatter> </div> <p class=can-import ng-if=!error>✔ Valid Swagger</p> </div> <div class=modal-footer> <button class=\"btn btn-warning\" ng-click=cancel()>Cancel</button> <button class=\"btn btn-primary\" ng-click=ok() ng-disabled=!canImport>Import</button> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./templates/paste-json.html
 ** module id = 395
 ** module chunks = 0
 **/